const statusCons = {
  S_COMPLETED_00: '00', // 已完成
  S_NOT_PAID_01: '01', // (普通、秒杀、预购、V币订单)提交订单, 待付款
  S_COD_SUBMIT_02: '02', // 货到付款提交, 待发货
  S_PAID_11: '11', // 付款成功, 待发货
  S_STOCK_OUT_21: '21', // 商品出库(目前实际状态变化中跳过此步骤), 待收货
  S_DELIVERYED_31: '31', // 待收货
  S_REFUNDED_81: '81', // 已退款
  S_TO_CHECK_97: '97', // 货到付款取消待审核，待审核
  S_EXPIRE_CLOSED_98: '98', // 超时关闭（如普通订单72小时，秒杀30分钟）, 已关闭
  S_CLOSED_99: '99', // 已关闭
  S_GroupOn_1: '1',
  S_GroupOn_2: '2',
  S_GroupOn_3: '3',
  S_TO_BOOK_101:101,// 售后服务待预约
  S_TO_STORE_102:102,// 售后服务待到店
  S_IN_SERVICE_103:103,// 售后服务服务中
  S_TO_CLAIM_104:104,// 售后服务待取货
  S_IN_TRANSIT_105:105,// 售后服务运输中
  S_TO_DOOR_107:107,// 售后服务待上门
}

const statusToDes = {
  '00': {
    label: '已完成',
    value: 'completed'
  },
  '01': {
    label: '待付款',
    value: 'not_paid'
  },
  '02': {
    label: '待发货',
    value: 'to_receive'
  },
  11: {
    label: '待发货',
    value: 'to_receive'
  },
  21: {
    label: '待收货',
    value: 'to_receive'
  },
  31: {
    label: '待收货',
    value: 'to_receive'
  },
  81: {
    label: '已退款',
    value: 'closed'
  },
  97: {
    label: '待审核',
    value: 'to_receive'
  },
  98: {
    label: '已关闭',
    value: 'closed'
  },
  99: {
    label: '已关闭',
    value: 'closed'
  },
  101:{
    label: '待预约',
    value: 'to_booked'
  },
  102:{
    label: '待到店',
    value: 'to_store'
  },
  103:{
    label: '服务中',
    value: 'service'
  },
  104:{
    label: '待取货',
    value: 'to_claim'
  },
  105:{
    label: '运输中',
    value: 'in_transit'
  },
  106:{
    label: '待发放',
    value: 'to_issue'
  },
  107:{
    label: '待上门',
    value: 'to_door'
  }
}

export { statusCons, statusToDes }
